// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lifeLinkPaymentPayoutGroup":"_2q_Ezh","headerInfo":"_2vR7zY","icon":"xxl2zY","lifeLinkPaymentPayoutTitle":"_2xAZG6","infoBtn":"_1BbuSM"};